import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../../notes/button/button.module';
import { ModalModule } from './../../notes/modal/modal.module';
import { FormGroupModule } from './../form-group/form-group.module';
import { FeedbackRatingComponent } from './feedback-rating/feedback-rating.component';
import { FeedbackComponent } from './feedback.component';

@NgModule({
  declarations: [FeedbackComponent, FeedbackRatingComponent],
  imports: [CommonModule, ModalModule, ButtonModule, FormGroupModule],
  exports: [FeedbackComponent],
})
export class FeedbackModule {}
